import { useMemo } from "react";
import { POLICY_DECISION_OPERATION_TYPE_OPTIONS } from "@constants/policy-decision-operation-type-options";
import { LabelWidthTypes } from "@enums/label-width-types";
import { PolicyDecisionOperationTypes } from "@enums/policy-decision-operation-types";
import { SelectOption } from "@idw-types/common";
import { SelectFormGroup } from "../../select-form-group/select-form-group";
import styles from "./policy-decision-operation-container.less";

type PolicyDecisionOperationContainerProps = {
    index: number;
    isDisabled: boolean;
    policyDecisionOperationType: PolicyDecisionOperationTypes;
    handlePolicyDecisionOperationTypeChange: (newValue: SelectOption) => void;
};

export const PolicyDecisionOperationContainer = (props: PolicyDecisionOperationContainerProps) => {
    const { index, isDisabled, policyDecisionOperationType, handlePolicyDecisionOperationTypeChange } = props;

    const selectedOption = useMemo(() => {
        return POLICY_DECISION_OPERATION_TYPE_OPTIONS.find(option => option.value === policyDecisionOperationType);
    }, [policyDecisionOperationType]);

    return (
        <div className={styles.policyDecisionOperationContainer}>
            <div className={styles.connector} />
            <SelectFormGroup
                controlId={`policy-decision-operation-type-select-${index}`}
                automationId={`policy-decision-operation-type-select-${index}`}
                className={styles.operationTypeSelect}
                ariaLabel={"Policy decision operation"}
                label={""}
                disabled={isDisabled}
                isClearable={false}
                isRequired={false}
                isSearchable={false}
                labelWidth={LabelWidthTypes.EXTRA_SMALL}
                onChange={handlePolicyDecisionOperationTypeChange}
                options={POLICY_DECISION_OPERATION_TYPE_OPTIONS}
                selectedOption={selectedOption}
            />
            <div className={styles.connector} />
        </div>
    );
};